import Route from '@ember/routing/route';

interface LocationOverviewPoliciesShowParams {
  policy_id: string;
}

export default class LocationOverviewPoliciesShowRoute extends Route {
  titleToken = 'Policy Details';

  model(params: LocationOverviewPoliciesShowParams): string {
    return params.policy_id;
  }
}
